import { UserOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const DelegateUserNameWrapper = styled.span`
  font-size: 16px;
  margin-right: 4px;
  .anticon {
    margin-right: 4px;
    opacity: 0.65;
    font-size: 1.2em;
  }
`;

export interface IDelegateUserNameProps {
  name?: string;
}

/**
 * Componente dinamico per la visualizzazione del nome di un delegato.
 */
export function DelegateUserName(props: IDelegateUserNameProps) {
  const { name } = props;
  const { t } = useTranslation();

  if (!name)
    return (
      <Tag color="default">{t('delegate-username.nessuno', 'Nessuno')}</Tag>
    );

  return (
    <DelegateUserNameWrapper>
      <UserOutlined aria-hidden />
      {name}
    </DelegateUserNameWrapper>
  );
}
